import React, { Component } from 'react';

export default class view extends Component {
	constructor(props) {
		super(props)
		this.state = {
		}
	}
	navcheck = (e) => {
		this.props.data.CIN = '';
		this.props.navigate('A2')
	}

	render() {
		return (
			<div style={{ textAlign: 'left', overflowWrap: 'break-word' }}>
				<p>There are no current prior authorizations on file for the CIN you entered. Any previous authorizations that may have been requested have expired.</p>

				<div className="button" onClick={() => this.navcheck()}>Perform an inquiry on a different member</div>
			</div>
		);
	}
}